export default __webpack_public_path__ + "static/media/doc_frontal_val.4f60fd30.svg";